<template lang="html">

  <section class="app-footer">
    <footer class="footer">
      <div class="container-fluid clearfix">
        <span class="text-muted d-block text-center">Copyright © {{anioActual}} <a href="https://pixancloud.com/" target="_blank">Pixan Cloud</a>. Derechos Reservados. | <a href="https://pixancloud.com/aviso-de-privacidad.html" target="_blank">Aviso de privacidad</a> | <a href="https://pixancloud.com/terminos-y-condiciones.html" target="_blank">Términos y condiciones</a></span>
        <!-- <span class="float-none float-xl-right d-block mt-1 mt-sm-0 text-center ">Developed by Honey Mustard</span> -->
      </div>
    </footer>
  </section>

</template>

<script lang="js">
export default {
  name: 'app-footer',
  data() {
    return {
      anioActual: (new Date()).getFullYear()
    }
  },
}
</script>

<style scoped lang="scss">
/* .app-footer {
} */
</style>



// WEBPACK FOOTER //
// src/components/partials/AppFooter.vue